var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-entry my-1 col col-md-6"},[_c('b-skeleton',{attrs:{"width":"90%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }